// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateGuestNicknameReducer extends Reducer
{
	public static reducerName: string = "UpdateGuestNickname";
	public static call(_nickname: string) {
		this.getReducer().call(_nickname);
	}

	public call(_nickname: string) {
		const serializer = this.client.getSerializer();
		let _nicknameType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_nicknameType, _nickname);
		this.client.call("UpdateGuestNickname", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let nicknameType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let nicknameValue = AlgebraicValue.deserialize(nicknameType, adapter.next())
		let nickname = nicknameValue.asString();
		return [nickname];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _nickname: string) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _nickname: string) => void)
	{
		this.client.on("reducer:UpdateGuestNickname", callback);
	}
}


export default UpdateGuestNicknameReducer
